<div class="row form-group">
  <div class="col-sm-12">
    <div class="card">
      <div class="card-body">
        <h2 class="card-title">Request Facilities Assistance</h2>
      </div>
    </div>
  </div>
</div>
<form #form="ngForm" (ngSubmit)="onSubmit(form)">
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <div class="card mb-3">
        <div class="card-body">
          <p class="card-title"><strong>Please Select A Location</strong></p>
          @for (resource of resources; track resource.resourceId) {
            <editable-radio-button-field (returnInput)="validate()" [(container)]="IssueForm" field="resourceId" [id]="resource.resourceName" value={{resource.resourceId}} [labelText]="resource.resourceName"></editable-radio-button-field>
          }
          <errors-warnings [(container)]="IssueForm" field="resourceId"></errors-warnings>
        </div>

      </div>
    </div>
  </div>
  @if (IssueForm.resourceId && issuesByType.length > 0) {
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <p class="card-title"><strong>Please Select An Issue</strong></p>
            @for (issue of issuesByType; track issue.issueId) {
              <editable-radio-button-field (returnInput)="validate()" [(container)]="IssueForm" field="issueId" [id]="issue.issueName" value={{issue.issueId}} [labelText]="issue.issueName"></editable-radio-button-field>
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (IssueForm.resourceId) {
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <editable-text-field (returnInput)="validate()" [(container)]="IssueForm" field="issueLocation" [labelText]="'Issue Location'" [placeholder]="'McColl 2575, bathroom by 3600, etc.'" [labelCols]="3"></editable-text-field>
          </div>
        </div>
      </div>
    </div>
  }
  @if (IssueForm.resourceId) {
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <editable-text-area (returnInput)="validate()" [(container)]="IssueForm" field="describeIssue" [labelText]="'Describe Issue'" [placeholder]="'more about the problem'" [labelCols]="3"></editable-text-area>
          </div>
        </div>
      </div>
    </div>
  }
  <!-- REQUIRED FIELDS -->
  <div class="row form-group">
    @if (objectKeys(IssueForm.errors).length > 0  && objectKeys(IssueForm.touched).length > 0) {
      <div class="card mb-3">
        <div class="card-body">
          <h4 class="card-title">Errors Summary</h4>
          @for (error of objectEntries(IssueForm.errors); track $index) {
            <p class="alert alert-danger"><i class="fas fa-exclamation-triangle text-danger"></i><span> {{error[1]}}</span></p>
          }
        </div>
      </div>
    }
  </div>
  <div [hidden]="!postError" class="alert alert-danger">
    {{postErrorMessage}}
  </div>
  <!-- SAVE Event -->
  <div class="row form-group">
    <div class="col-sm-12">
      <button class="btn btn-primary" type="submit" [disabled]="objectKeys(IssueForm.errors).length > 0 || submittingToServer">
        Submit @if (submittingToServer) {
        <span><i class="fas fa-circle-notch fa-spin"></i></span>
      }
    </button>
    <button class="btn btn-outline-secondary" type="button" style="margin-left: 5px" (click)="close()" [disabled]="submittingToServer">
      Cancel
    </button>
  </div>
</div>
@if (emergencyWeekendInfo != '') {
  <div class="row form-group">
    <div class="col-sm-12">
      <div class="card-body">
        <p>{{emergencyWeekendInfo}}</p>
      </div>
    </div>
  </div>
}
</form>

